import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { LzCookieService } from "../../../../services/lz-cookie/lz-cookie";
import { AfterContentInit, Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Subscription, interval, Observable } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import { CustomRequestService } from "../../../../services/custom-request/custom-request.service";
import { LzUserServiceV2 } from "../../../lz-user/services/lz-user.serivce.v2";
import { LzProductConfig } from "../../../../services/product-config/poduct-config";
import { InvisibleReCaptchaComponent } from 'ngx-captcha';
import { LzThnxForPurchaseService } from "../../services/lz-thnxForPurchase.service";

import { LzLanguageService } from '../../../../services/lz-language/lz-language.service';

declare var $: any;
declare var grecaptcha: any;

@Component({
  selector: 'app-lz-purchase-new',
  template: `<div class="order-test">

  <div class="order-test">


    <div *ngIf="showSlider === true" class="slider-container">
      <div class="slider-title">
        <img src="{{product.logoSmall}}" alt=""><div class="product-name">{{product.title}}</div>
      </div>
      <div class="close-mobile" *ngIf="showSlider === true" (click)="cancel()"><i class="fa fa-remove"></i></div>
      <div class="slider-desc"><p>{{product.description}}</p></div>
      <div class="line" [ngStyle]="{'background-color': product.backgroundColor}"></div>
      <div class="desc" *ngIf="product.presentation.video"><p>{{product.presentation.descriptionBottom}}</p></div>
      <div *ngFor="let slide of product.presentation.slides"><div class="desc" *ngIf="!product.presentation.video && slide == currentActiveImg"><p>{{slide.description}}</p></div></div>
      <div class="mobile-wrapper" [ngClass]="{'video': product.presentation.video}">
        <div class="laptop"><img src="/dist/ng2/src/assets/pl-header-assets/img/laptop.png" alt=""></div>
        <div class="mobile-control left" *ngIf="!product.presentation.video"><i class="fa fa-chevron-left" (click)="setActivePrev()"></i></div>
        <div class="slider-wrapper" *ngIf="!product.presentation.video">
          <div class="slider-item"  id="swipe"  *ngFor="let img of product.presentation.slides"
               [ngClass]="{'active': img == currentActiveImg}">
            <img src="{{img.src}}">
          </div>
        </div>
        <div class="video-container" *ngIf="product.presentation.video">
          <iframe width="430" height="242"
                  [src]="videoUrl">
          </iframe>
        </div>
        <div class="mobile-control right" *ngIf="!product.presentation.video"><i class="fa fa-chevron-right" (click)="setActiveNext()"></i></div>
      </div>
      <!--<div class="controls" *ngIf="!product.presentation.video">-->
      <!--<i class="fa fa-chevron-left" (click)="setActivePrev()"></i>-->
      <!--<div class="middle"></div>-->
      <!--<i class="fa fa-chevron-right" (click)="setActiveNext()"></i>-->
      <!--</div>-->
    </div>

    <div class="right-block">
      <div *ngIf="showSlider == true" class="order-test-footer">
        <!--<div class="footer-title">-->
        <!--<p>{{'user.signinup.unitedProfile' | translate}}</p>-->
        <!--</div>-->
        <!--<div class="footer-list">-->
        <!--<ul>-->
        <!--<li *ngFor="let item of products">-->
        <!--<a target="_blank" rel="noopener noreferrer" href="{{item.enterLink}}">{{item.title}}</a>-->
        <!--</li>-->
        <!--<li>-->
        <!--<a target="_blank" rel="noopener noreferrer" href="http://platforma.ligazakon.net">{{'user.signinup.others' | translate}}</a>-->
        <!--</li>-->
        <!--</ul>-->
        <!--</div>-->
      </div>
      <div class="order-test-form">
        <div class="close-mobile" *ngIf="showSlider === false" (click)="cancel()"><i class="fa fa-remove"></i></div>
        <div class="lz-logo"><img src="/dist/ng2/src/assets/pl-header-assets/img/cutted-logo.png" alt=""></div>
        <div class="lz-logo-mobile"><img src="/dist/ng2/src/assets/pl-header-assets/img/lz-logo.png" alt=""></div>
        <h1>{{'lzPurchase.order' | translate}}<br/> ÑÐµÑÑ</h1>
        <div class="close" (click)="cancel()"><i class="fa fa-remove"></i></div>
        <form name="orderForm" [formGroup]="orderForm"  novalidate>
          <div class="form-group">
            <input type="text"
                   class="input-field"
                   name="firstname"
                   id="{{alias}}-main_lznet-click-firstname_field-input-popup_register-1"
                   [(ngModel)]="buy.firstName"
                   formControlName="firstname"
                   placeholder="{{'user.signinup.firstname' | translate}}" [maxlength]="256" [ngClass]="{'submitted' : this.submitted}"
                   required>
            <div class="error-field" *ngIf="(orderForm.get('firstname').invalid && orderForm.get('firstname').touched) || serverError">
              <span *ngIf="serverValidation.firstName.invalid">{{serverValidation.firstName.message}}</span>
            </div>
          </div>
          <div class="form-group">


            <input type="text" class="input-field" name="lastname" id="{{alias}}-main_lznet-click-lastname_field-input-popup_register-1"
                   [(ngModel)]="buy.lastName" formControlName="lastname"
                   placeholder="{{'user.signinup.lastname' | translate}}" [ngClass]="{'submitted' : this.submitted}"
                   [maxlength]="256" required>
            <div class="error-field" *ngIf="orderForm.get('lastname').invalid && orderForm.get('lastname').touched">
            </div>
          </div>
          <div class="form-group">

            <input type="text"
                   class="input-field"
                   name="email"
                   id="{{alias}}-main_lznet-click-email_field-input-popup_register-1"
                   [(ngModel)]="buy.email"
                   formControlName="email"
                   placeholder="{{'lzPurchase.emailLabel' | translate}}" [maxlength]="256" [ngClass]="{'submitted' : this.submitted}"
                   required>
            <div class="error-field" *ngIf="(orderForm.get('email').invalid && orderForm.get('email').touched) || serverError">
              <span *ngIf="!serverError && orderForm.get('email')['errors']['pattern']">{{'user.signinup.emailRegPattern' | translate}}</span>
              <span *ngIf="serverValidation.email.invalid">{{serverValidation.email.message}}</span>
            </div>
            <div class="qmark"><div class="hint"><p>{{'user.signinup.tip' | translate}}</p></div><i class="fa fa-question-circle-o"></i></div>
          </div>
          <div class="form-group">

            <input *ngIf="useMask" type="text"
                   class="input-field phone"
                   name="phone"
                   id="{{alias}}-main_lznet-click-phone_field-input-popup_register-1"
                   [(ngModel)]="buy.phone" [textMask]="{mask: mask}"
                   formControlName="phone"
                   placeholder="{{'user.signinup.phone' | translate}}" [ngClass]="{'submitted' : this.submitted}"
                   required>
            <input *ngIf="!useMask" type="text"
                   class="input-field phone"
                   name="phone"
                   id="{{alias}}-main_lznet-click-phone_field-input-popup_register-1"
                   [(ngModel)]="buy.phone"
                   formControlName="phone"
                   placeholder="{{'user.signinup.phone' | translate}}" [ngClass]="{'submitted' : this.submitted}"
                   required>
            <div class="error-field" *ngIf="(orderForm.get('phone').invalid && orderForm.get('phone').touched) || serverError">
              <!--<span *ngIf="!serverError && orderForm.get('phone')['errors']['pattern']">{{'lzPurchase.phonePattern' | translate}}</span>-->
              <span *ngIf="serverValidation.phone.invalid">{{serverValidation.phone.message}}</span>
            </div>
          </div>
          <div class="form-group">

            <input type="text" class="input-field" name="company" id="{{alias}}-main_lznet-click-companyname_field-input-popup_register-1"
                   [(ngModel)]="buy.companyName" formControlName="company"
                   placeholder="{{'user.signinup.companyName' | translate}}" [ngClass]="{'submitted' : this.submitted}"
                   [maxlength]="256" required>
            <div class="error-field" *ngIf="(orderForm.get('company').invalid && orderForm.get('company').touched) || serverError">
              <span *ngIf="serverValidation.companyName.invalid">{{serverValidation.companyName.message}}</span>
            </div>
          </div>

          <fieldset onclick="" class="check">
            <label class="container" onclick="">{{'user.signinup.agree' | translate}}<a target="_blank" rel="noopener noreferrer" id="{{alias}}-main_lznet-click-rules-link-popup_register-1"
                                                                                        href="http://support1.ligazakon.ua/politika-konfidencijnosti-ta-obrobki-personalnix-danix">
              {{'user.signinup.personalData' | translate}}</a>{{'user.signinup.and' | translate}}<a target="_blank" rel="noopener noreferrer" id="{{alias}}-click-licen_agree-link-popup_register-1"
                                                                                                    href="https://ligazakon.net/license">{{'user.signinup.license' | translate}}</a>
              <div class="error-field-confirmData" *ngIf="(orderForm.get('confirmDataSaving').invalid && orderForm.get('confirmDataSaving').touched) ||
                        (orderForm.get('confirmDataSaving').invalid && orderForm.get('confirmDataSaving').dirty) ||
                        (orderForm.get('confirmDataSaving').invalid && this.submitted)">
                <span>{{'lzPurchase.regConfirmDataError' | translate}}</span>
                <div class="pointer"></div>
              </div>
              <input type="checkbox" class="form-control confirmDataSavingCheckbox"
                     formControlName="confirmDataSaving"
                     id="{{alias}}-main_lznet-click-i_agree-chkbox-popup_register-1"
              >

              <span class="checkmark"></span>
            </label>

          </fieldset>
          <button id="{{alias}}-click-order_test-button-popup_ordertest-1" (click)="execute()" [ngClass]="{'loading': isDisabled}" [disabled]="isDisabled"><p *ngIf="!isDisabled">{{'lzPurchase.order' | translate}}</p><lz-preloader *ngIf="isDisabled"></lz-preloader></button>
        </form>
        <!--<section class="social-network">-->
        <!--<div class="or"><span>{{'user.signinup.orBlock' | translate}}</span></div>-->
        <!--<div class="social-network_icons">-->
        <!--<div class="social-network_btn" (click)="getToken('/lzwpservice/authorize/authSN/facebook')">-->
        <!--<i class="fa fa-facebook"></i>-->
        <!--</div>-->
        <!--<div class="social-network_btn" (click)="getToken('/lzwpservice/authorize/authSN/google')">-->
        <!--<i class="fa fa-google-plus"></i>-->
        <!--</div>-->
        <!--<div class="social-network_btn" (click)="getToken('/lzwpservice/authorize/authSN/linkedin')">-->
        <!--<i class="fa fa-linkedin"></i>-->
        <!--</div>-->
        <!--</div>-->
        <!--</section>-->
      </div>
      <!--<div class="order-footer-mobile">-->
      <!--<div class="footer-title">-->
      <!--<p>{{'user.signinup.unitedProfile' | translate}}</p>-->
      <!--</div>-->
      <!--<div class="footer-list">-->
      <!--<ul>-->
      <!--<li *ngFor="let item of products">-->
      <!--<a target="_blank" rel="noopener noreferrer" href="{{item.enterLink}}">{{item.title}}</a>-->
      <!--</li>-->
      <!--<li>-->
      <!--<a target="_blank" rel="noopener noreferrer" href="http://platforma.ligazakon.net">{{'user.signinup.others' | translate}}</a>-->
      <!--</li>-->

      <!--</ul>-->
      <!--</div>-->
      <!--</div>-->
    </div>


    <form [formGroup]="cFormGroup">
    <ngx-invisible-recaptcha hl="uk" #captchaRef (success)="orderTest($event)" siteKey="6LcfMkgUAAAAAOmzWe6krfV-cgR3MczaQVrqxUVR"
      formControlName="recaptcha"></ngx-invisible-recaptcha>
  </form>
</div>
`,
  styles: [`*{margin:0;padding:0}::ng-deep .cdk-global-scrollblock{position:static!important;overflow:hidden}::ng-deep .cdk-global-scrollblock body{overflow:hidden}::ng-deep .cdk-overlay-backdrop{background:rgba(0,0,0,.588)}::ng-deep .cdk-overlay-container .myPane .mat-dialog-container{margin:0;max-height:95vh;max-width:95vw;border-radius:0;padding:0;background:rgba(0,0,0,0);-webkit-box-shadow:none;box-shadow:none;opacity:1;overflow:visible;font-family:Geometria,sans-serif;font-weight:400}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover{border:0;-webkit-text-fill-color:#fff;-webkit-box-shadow:0 0 0 1000px transparent inset;-webkit-transition:background-color 5000s ease-in-out;transition:background-color 5000s ease-in-out;background:-webkit-linear-gradient(top,rgba(255,255,255,0) 0,rgba(0,174,255,.04) 50%,rgba(255,255,255,0) 51%,rgba(0,174,255,.03) 100%)}.order-test{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative}.order-test .slider-container{width:580px;height:585px;background-color:#fff;position:absolute;top:-35px;left:-80px;padding:0 75px}@media (max-width:1199px){::ng-deep .cdk-overlay-container .myPane{max-width:640px!important}::ng-deep .cdk-overlay-container .myPane .mat-dialog-container{overflow-x:hidden;max-width:640px}.order-test{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.order-test .slider-container{width:635px;height:auto;position:relative;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;top:0;left:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;padding:0 30px}}.order-test .slider-container .slider-title{margin-top:30px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.order-test .slider-container .slider-title img{margin-right:10px}@media (max-width:1199px){.order-test .slider-container .slider-title{margin-left:0;width:321px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}.order-test .slider-container .slider-title .product-name{font-weight:700;font-size:34px;text-align:left;line-height:30px}.order-test .slider-container .close-mobile{position:absolute;border:1px solid #c0c5e2;color:#c0c5e2;right:10px;top:10px;width:35px;padding:5px;text-align:center;cursor:pointer;display:none}@media (max-width:420px){.order-test .slider-container .close-mobile{right:60px}}.order-test .slider-container .slider-desc{margin-top:10px;font-size:14px}@media (max-width:1199px){.order-test .slider-container .close-mobile{display:block}.order-test .slider-container .slider-desc{margin-left:0;margin-top:5px}}@media (max-width:758px){::ng-deep .cdk-overlay-container .myPane{max-width:450px!important}::ng-deep .cdk-overlay-container .myPane .mat-dialog-container{max-width:450px}.order-test{width:450px}.order-test .slider-container{width:450px;max-width:100%}.order-test .slider-container .slider-title .product-name{font-size:25px}.order-test .slider-container .slider-desc{margin-left:20px;margin-right:20px}}.order-test .slider-container .line{margin-top:10px;width:50px;height:3px}@media (max-width:1199px){.order-test .slider-container .line{margin-left:0;margin-top:5px}}.order-test .slider-container .desc{margin-top:10px;font-size:18px;font-weight:700;width:430px;line-height:125%;height:70px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}@media (max-width:430px){.order-test .slider-container .desc{width:300px}}.order-test .slider-container .mobile-wrapper .laptop{position:absolute;left:25px;top:240px}@media (max-width:1199px){.order-test .slider-container .desc{margin-left:0;margin-top:5px;height:auto;display:block}.order-test .slider-container .mobile-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:5px 0 90px;font-size:21px;width:95%}.order-test .slider-container .mobile-wrapper .laptop{bottom:25px;top:auto;width:585px;z-index:0;pointer-events:none}.order-test .slider-container .mobile-wrapper .laptop img{width:100%}}@media (max-width:758px){.order-test .slider-container .mobile-wrapper{margin:5px 0 20px;width:80%}.order-test .slider-container .mobile-wrapper .laptop{display:none}}.order-test .slider-container .mobile-wrapper.video{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.order-test .slider-container .slider-wrapper{margin-top:15px;height:261px;width:430px;display:-webkit-box;display:-ms-flexbox;display:flex;overflow:hidden;bottom:66px;position:absolute}.order-test .slider-container .slider-wrapper img{max-width:unset}@media (max-width:1199px){.order-test .slider-container .slider-wrapper{width:465px;height:285px;top:25px;margin-left:0;margin-top:0;position:relative;bottom:0}.order-test .slider-container .slider-wrapper img{width:465px;height:285px}}@media (max-width:758px){.order-test .slider-container .slider-wrapper{width:320px;height:180px;top:auto}.order-test .slider-container .slider-wrapper img{width:320px;height:180px}}.order-test .slider-container .video-container{margin-top:15px}.order-test .slider-container .mobile-control{display:block;color:#000;position:absolute;top:64%;cursor:pointer}.order-test .slider-container .mobile-control.left{left:40px}.order-test .slider-container .mobile-control.right{right:40px}@media (max-width:1199px){.order-test .slider-container .video-container{margin-left:0;margin-bottom:0;margin-top:5px}.order-test .slider-container .mobile-control{position:relative;top:20px;display:block;color:#d6d6d6}.order-test .slider-container .mobile-control.left{left:auto}.order-test .slider-container .mobile-control.right{right:auto}}@media (max-width:758px){.order-test .slider-container .mobile-control{position:relative;top:0;display:block;color:#d6d6d6}.order-test .slider-container .mobile-control.left{left:-20px}.order-test .slider-container .mobile-control.right{right:-20px}}.order-test .slider-container .controls{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;right:240px;bottom:40px}.order-test .slider-container .controls .middle{width:65px}.order-test .slider-container .controls .fa{cursor:pointer}.order-test .right-block{display:-webkit-box;display:-ms-flexbox;display:flex;background:-webkit-gradient(linear,left bottom,left top,from(#3b60f7),to(#2741b0));background:linear-gradient(0deg,#3b60f7 0,#2741b0 100%)}@media (max-width:1199px){.order-test .slider-container .controls{display:none}.order-test .right-block{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column}}.order-test .right-block .order-test-footer{width:500px;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.order-test .right-block .order-test-footer .footer-title{text-align:center;color:#a3aef5;font-size:12px}.order-test .right-block .order-test-footer ul{list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:0 35px 35px 65px;font-size:10px;font-weight:800}.order-test .right-block .order-test-footer ul li{margin-top:15px;margin-right:25px;width:75px;line-height:90%;letter-spacing:-.1px}.order-test .right-block .order-test-footer ul li a{color:#7383f1}.order-test .right-block .order-test-footer ul li:last-child{font-weight:400;font-size:12px}.order-test .right-block .order-test-footer ul li:last-child a{color:#a3aef5}.order-test .right-block .order-test-form{padding:45px 30px 39px;font-family:Geometria,sans-serif;font-weight:400;width:370px;max-width:100%;position:relative}.order-test .right-block .order-test-form .close-mobile{position:absolute;border:1px solid #c0c5e2;color:#c0c5e2;right:10px;top:10px;width:35px;padding:5px;text-align:center;cursor:pointer;display:none}@media (max-width:420px){.order-test .right-block .order-test-form .close-mobile{right:60px}}.order-test .right-block .order-test-form .lz-logo{position:absolute;top:.2px;left:0}@media (max-width:1199px){.order-test .right-block .order-test-footer{display:none}.order-test .right-block .order-test-form{width:545px;padding:25px 120px 20px}.order-test .right-block .order-test-form .close-mobile{display:block}.order-test .right-block .order-test-form .lz-logo{display:none}}.order-test .right-block .order-test-form .lz-logo img{width:120%}.order-test .right-block .order-test-form .lz-logo-mobile{display:none;position:absolute}@media (max-width:1199px){.order-test .right-block .order-test-form .lz-logo-mobile{display:block;top:-25px;left:75px}.order-test .right-block .order-test-form .mobile-title{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}@media (max-width:758px){.order-test .right-block .order-test-form{width:450px;max-width:100%;padding:25px 68px 10px}.order-test .right-block .order-test-form .lz-logo-mobile{top:-25px;left:25px}}.order-test .right-block .order-test-form .lz-logo-mobile img{width:125px}.order-test .right-block .order-test-form h1{color:#fff;font-size:36px;font-weight:700;margin-bottom:15px}.order-test .right-block .order-test-form .signIn-mobile{color:#ffbe26;text-transform:uppercase;text-align:center;font-weight:700;letter-spacing:1px;margin-bottom:15px;margin-top:3px;display:none}.order-test .right-block .order-test-form .signIn-mobile span{cursor:pointer}.order-test .right-block .order-test-form .close{position:absolute;border:1px solid #727dc7;color:#727dc7;left:312px;top:20px;width:35px;padding:5px;text-align:center;cursor:pointer}.order-test .right-block .order-test-form .form-group{position:relative}.order-test .right-block .order-test-form .form-group .error-required{font-style:normal;font-weight:400;color:#ff564e;position:absolute;top:8px;left:0;z-index:0;font-size:14px;cursor:text}@media (max-width:1199px){.order-test .right-block .order-test-form h1{font-size:24px;margin-bottom:10px}.order-test .right-block .order-test-form .signIn-mobile{display:block}.order-test .right-block .order-test-form .close{display:none}.order-test .right-block .order-test-form .form-group .error-required{font-size:12px}}.order-test .right-block .order-test-form .form-group .error-field{position:absolute;color:#fff;background-color:#ff564e;font-size:12px;top:25px;width:100%;z-index:0}.order-test .right-block .order-test-form .form-group .error-field span{display:table;margin:3px;line-height:1}.order-test .right-block .order-test-form .form-group .qmark{color:#ffbe26;cursor:pointer;position:absolute;top:0;right:0;font-size:23px}.order-test .right-block .order-test-form .form-group .qmark i{opacity:.5}.order-test .right-block .order-test-form .form-group .qmark .hint{padding:10px 5px;font-size:12px;background-color:#fff;display:none}.order-test .right-block .order-test-form .form-group .qmark:hover{color:#3b60f7}.order-test .right-block .order-test-form .form-group .qmark:hover .hint{z-index:1;display:block}.order-test .right-block .order-test-form .form-group .qmark:hover .hint p{color:#000}.order-test .right-block .order-test-form .form-group .qmark:hover i{z-index:2;position:absolute;top:3px;left:289px}.order-test .right-block .order-test-form .form-label{width:100%;color:#fff;font-weight:bolder;font-size:14px;opacity:0}.order-test .right-block .order-test-form .form-group:focus-within label{opacity:0}.order-test .right-block .order-test-form .input-field{background-color:rgba(0,0,0,0);color:#fff;border:none;border-bottom:1px solid #fff;width:100%;height:30px;z-index:1;margin-bottom:22.4px}.order-test .right-block .order-test-form .input-field.ng-invalid.ng-touched{border-bottom:1px solid #ff564e;color:#ff564e}.order-test .right-block .order-test-form .input-field:focus{border-bottom:1px solid #ffbe26}.order-test .right-block .order-test-form .input-field::-webkit-input-placeholder{font-style:normal;font-weight:400;color:#fff;z-index:-10}.order-test .right-block .order-test-form .input-field::-ms-input-placeholder{font-style:normal;font-weight:400;color:#fff;z-index:-10}.order-test .right-block .order-test-form .input-field::placeholder{font-style:normal;font-weight:400;color:#fff;z-index:-10}.order-test .right-block .order-test-form .input-field.ng-invalid.ng-touched::-webkit-input-placeholder{color:#ff564e}.order-test .right-block .order-test-form .input-field.ng-invalid.ng-touched::-ms-input-placeholder{color:#ff564e}.order-test .right-block .order-test-form .input-field.ng-invalid.ng-touched::placeholder{color:#ff564e}.order-test .right-block .order-test-form .input-field.ng-invalid.submitted::-webkit-input-placeholder{color:#ff564e}.order-test .right-block .order-test-form .input-field.ng-invalid.submitted::-ms-input-placeholder{color:#ff564e}.order-test .right-block .order-test-form .input-field.ng-invalid.submitted::placeholder{color:#ff564e}.order-test .right-block .order-test-form .input-field:focus::-webkit-input-placeholder{opacity:.5}.order-test .right-block .order-test-form .input-field:focus::-ms-input-placeholder{opacity:.5}.order-test .right-block .order-test-form .input-field:focus::placeholder{opacity:.5}.order-test .right-block .order-test-form button{width:100%;background-color:#ffbe26;color:#303f9f;text-transform:uppercase;padding:15px;border:none;font-size:16px;font-weight:800;margin-bottom:20px;letter-spacing:1px;display:flex;display:-webkit-box;display:-ms-flexbox;justify-content:center;-webkit-box-pack:center;-ms-flex-pack:center;text-align:-webkit-center;text-align:-moz-center}.order-test .right-block .order-test-form button.loading{padding:23.5px}.order-test .right-block .order-test-form .signIn{color:#ffbe26;text-transform:uppercase;text-align:center;font-size:14px;font-weight:700;letter-spacing:1px;margin-bottom:15px}@media (max-width:1199px){.order-test .right-block .order-test-form .form-group .qmark:hover i{left:285px}.order-test .right-block .order-test-form button{margin-bottom:15px}.order-test .right-block .order-test-form .signIn{display:none}}.order-test .right-block .order-test-form .signIn span{cursor:pointer}.order-test .right-block .order-test-form .check{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;margin-top:0}.order-test .right-block .order-test-form .check .container{display:block;position:relative;padding-left:35px;margin-bottom:12px;cursor:pointer;font-size:12px;font-weight:400;color:#fff;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.order-test .right-block .order-test-form .check .container input{position:absolute;opacity:0;cursor:pointer;top:-18px;left:-2px;width:30px}.order-test .right-block .order-test-form .check .container a{color:#ffbe26}.order-test .right-block .order-test-form .check .container .error-field-confirmData{position:absolute;color:#fff;background-color:#ff564e;font-size:12px;width:100%;z-index:0;top:-37px;right:0}.order-test .right-block .order-test-form .check .container .error-field-confirmData span{display:table;margin:3px;line-height:1}.order-test .right-block .order-test-form .check .container .error-field-confirmData .pointer{width:10px;height:10px;position:absolute;left:8px;bottom:-3px;z-index:-1;background-color:#ff564e;display:table;transform:rotate(45deg);-webkit-transform:rotate(45deg)}.order-test .right-block .order-test-form .check .checkmark{position:absolute;top:0;left:0;height:25px;width:25px;background-color:#eee0;border:1px solid #fff}.order-test .right-block .order-test-form .check .container:hover input~.checkmark{background-color:#ccc0}.order-test .right-block .order-test-form .check .container input:checked~.checkmark{background-color:#ffbe26;border:none}.order-test .right-block .order-test-form .check .checkmark:after{content:"";position:absolute;display:none}.order-test .right-block .order-test-form .check .container input:checked~.checkmark:after{display:block}.order-test .right-block .order-test-form .check .container .checkmark:after{left:9px;top:5px;width:8px;height:13px;border:solid #303f9f;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.order-test .right-block .order-test-form .or{overflow:hidden;text-align:center;color:#b2b9f1;font-size:14px;letter-spacing:1px;font-weight:700;margin-bottom:20px}@media (max-width:1199px){.order-test .right-block .order-test-form .check .container{font-size:10px;padding-left:35px}.order-test .right-block .order-test-form .or{margin-bottom:15px}}.order-test .right-block .order-test-form .or:after,.order-test .right-block .order-test-form .or:before{background-color:#576ae6;content:"";display:inline-block;height:2px;top:50px;width:50%}.order-test .right-block .order-test-form .or:before{right:.5em;margin-left:-50%;margin-right:5px}.order-test .right-block .order-test-form .or:after{left:.5em;margin-right:-50%;margin-left:5px}.order-test .right-block .order-test-form .social-network_icons{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.order-test .right-block .order-test-form .social-network_icons .social-network_btn{width:85px;max-width:100%;color:#ffbe26;background-color:#596ceb;text-align:center;padding:20px 0;cursor:pointer}.order-test .right-block .order-test-form .social-network_icons .social-network_btn:hover{background-color:#fff}.order-test .right-block .order-test-form .social-network_icons .social-network_btn:hover .fa-facebook{color:#3b5998}.order-test .right-block .order-test-form .social-network_icons .social-network_btn:hover .fa-google-plus{color:#dd4b39}.order-test .right-block .order-test-form .social-network_icons .social-network_btn:hover .fa-linkedin{color:#0077b5}.order-test .order-footer-mobile{width:545px;display:none}@media (max-width:1199px){.order-test .right-block .order-test-form .social-network_icons .social-network_btn{background-color:#fff;padding:5px 0}.order-test .right-block .order-test-form .social-network_icons .social-network_btn .fa-facebook{color:#3b5998}.order-test .right-block .order-test-form .social-network_icons .social-network_btn .fa-google-plus{color:#dd4b39}.order-test .right-block .order-test-form .social-network_icons .social-network_btn .fa-linkedin{color:#0077b5}.order-test .order-footer-mobile{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex}}.order-test .order-footer-mobile .footer-title{text-align:center;color:#a3aef5;font-size:12px}.order-test .order-footer-mobile ul{list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:0 35px 35px 65px;font-size:10px;font-weight:800}@media (max-width:1199px){.order-test .order-footer-mobile ul{margin:0 35px 20px 65px}}.order-test .order-footer-mobile ul li{margin-top:15px;margin-right:25px;width:75px;line-height:90%;letter-spacing:-.1px}.order-test .order-footer-mobile ul li a{color:#7383f1}@media (max-width:758px){.order-test .right-block .order-test-form .form-group .qmark:hover i{left:293px}.order-test .right-block .order-test-form .or,.order-test .right-block .order-test-form button{margin-bottom:10px}.order-test .order-footer-mobile{width:450px}.order-test .order-footer-mobile ul li:nth-child(6),.order-test .order-footer-mobile ul li:nth-child(7){display:none}.order-test .order-footer-mobile ul li:nth-child(2),.order-test .order-footer-mobile ul li:nth-child(5){text-align:center}}.order-test .order-footer-mobile ul li:last-child{font-weight:400;font-size:12px}.order-test .order-footer-mobile ul li:last-child a{color:#a3aef5}.thnx-modal{background:-webkit-gradient(linear,left bottom,left top,from(#3b60f7),to(#2741b0));background:linear-gradient(0deg,#3b60f7 0,#2741b0 100%);padding:50px;width:350px;position:relative;overflow:hidden}.thnx-modal .lz-logo{position:absolute;top:-15px;left:-20px}.thnx-modal .lz-logo img{width:125px}.thnx-modal .close{position:absolute;border:1px solid #727dc7;color:#727dc7;right:10px;top:10px;width:35px;padding:5px;text-align:center;cursor:pointer}.thnx-modal .tnx-for-purchase{color:#fff;font-size:16px}.thnx-modal .tnx-for-purchase .msg{opacity:.5}`],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})

export class LzPurchaseNewComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(InvisibleReCaptchaComponent) captcha: InvisibleReCaptchaComponent;
  private lang: string;
  public useMask = true;
  public showSlider = true;
  public orderForm: FormGroup;
  public cFormGroup: FormGroup;
  isDisabled = false;
  submitted = false;
  EMAIL_REGEXP = /^[a-z0-9._-]+@[a-z0-9._-]+\.[a-z0-9]{2,}$/i;
  PHONE_REGEXP = /^(\+\d{3} \(\d{2}\) \d{3}-\d{2}-\d{2})|(\d{10})|(\+?\d{12})/;
  public mask = ['+', '3', '8', '0', ' ', '(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  isDisableCancel = false;
  isDisabledSubmitButton = false;
  location: Location;
  from: string;
  isTrial: boolean;
  buy: any = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyName: '',
    dealerId: '',
    message: ''
  };
  serverValidation = {
    email: {
      invalid: false,
      message: ""
    },
    firstName: {
      invalid: false,
      message: ""
    },
    companyName: {
      invalid: false,
      message: ""
    },
    phone: {
      invalid: false,
      message: ""
    }
  };
  serviceOpenThnx;
  serverError: boolean = false;
  public product = {
    "category": [
      ""
    ],
    "alias": "",
    "sortOrder": 0,
    "backgroundColor": "",
    "fontColor": "",
    "hoverColor": "",
    "title": "",
    "subTitle": "",
    "description": "",
    "logo": "",
    "logoSmall": "",
    "logoSmall2": "",
    "banner": "",
    "bannerSmall": "",
    "hasTest": '',
    "moreLink": "",
    "buyLink": "",
    "enterLink": "",
    "price": "",
    "priceType": "",
    "oldPrice": "",
    "oldPriceType": "",
    "saleTypes": [{
      "alias": "",
      "name": "",
      "image": ""
    }],
    "presentation": {
      "logo": "",
      "descriptionTop": "",
      "descriptionBottom": "",
      "color": "",
      "video": "",
      "slides": [{
        "src": "",
        "description": ""
      }]
    },
    "visible": true
  };
  public currentActiveImg = this.product.presentation.slides[0];
  public currentActiveImgPosition: number;
  public controlAnimation: string = '0';
  public isAnimate: boolean = false;
  public sliderWidth;
  public documentWidth = 0;
  public isSliderFirstPick = true;
  public lastSwipeElement;
  public products = [];

  private sub0: Subscription;
  private sub1: Subscription;
  private sub2: Subscription;
  private sub3: Subscription;
  private sub4: Subscription;
  public alias;
  videoUrl;
  private config;
  private needToDisable = true;
  public resolved(captchaResponse: string) {}
  public checked = false;


  constructor(private language: LzLanguageService,
    private dialogRef: MatDialogRef < LzPurchaseNewComponent > ,
    private translate: TranslateService,
    private dialog: MatDialog,
    public sanitizer: DomSanitizer,
    private lzCookie: LzCookieService,
    private customRequestService: CustomRequestService,
    private user: LzUserServiceV2,
    private thnxForPurchase: LzThnxForPurchaseService,
    private lzProductConfig: LzProductConfig,
    @Inject(MAT_DIALOG_DATA) public presentantionData: any,
    @Inject(DOCUMENT) private document: any) {

    this.lang = this.language.identifyLanguage();
    this.config = lzProductConfig.getProductSettings();
    this.getProductsForFooter();
    this.alias = presentantionData.orderCode || this.config['order_code'] || 'platforma';
    this.showSlider = (this.config['isShowSlidersOnRegAndTestFroms'] === 'show') ? ((this.presentantionData && this.presentantionData.disableSlider) ? false : true) : false;
  }

  ngAfterContentInit() {
    if(this.showSlider) {
      this.getProductPresentation(this.alias);
    }
  }

  ngOnInit() {
    this.user.getUserInfo((data) => {
      if (data.anonymous == false) {
        this.PHONE_REGEXP = /^\+?[0-9]{7,16}$/;

        this.useMask = false;

      }
    });

    this.orderForm = new FormGroup({
      'firstname': new FormControl(null, [Validators.required]),
      'lastname': new FormControl(null, [Validators.required]),
      'email': new FormControl(null, [Validators.required, Validators.pattern(this.EMAIL_REGEXP)]),
      'phone': new FormControl(null, [Validators.required, Validators.pattern(this.PHONE_REGEXP)]),
      'company': new FormControl(null, [Validators.required]),
      'confirmDataSaving': new FormControl(null, [Validators.requiredTrue])
    });
    this.cFormGroup = new FormGroup({
      'recaptcha': new FormControl(null, [Validators.required])
    });
    this.watchErrorRequired();
    this.doPurchase();

    // this.dialogRef.afterClosed().subscribe(() => {
    //     // this.document.querySelector(".cdk-overlay-container").remove();
    // });
  }
  toggleCheckbox() {
    this.checked = !this.checked;
  }
  cancel() {
    this.dialogRef.close();
  };

  getToken(service) {
    location.href = service;
  }

  getProductsForFooter() {
    this.sub4 = this.customRequestService.getRequest(this.lzProductConfig.getApiLink() + "/lz-platforma/product/v1.0/all")
      .subscribe((msg) => {
        this.products = msg.slice(0, 7);
        for (let i: number = 0; i < this.products.length; i++) {
          this.products[i].title = this.products[i].title.replace('&', ' &');
        }
      })
  }

  getProductPresentation(alias: string) {
    let video;

    this.sub1 = this.customRequestService.getRequest(this.lzProductConfig.getApiLink() + "/lz-platforma/product/v1.0/info/" + alias)
      .subscribe((msg) => {
        this.product = msg;
        video = this.product.presentation.video.replace('watch?v=', 'embed/');
        this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(video);
        setTimeout(this.setActiveSpecified(this.product.presentation.slides[0]), 0);
      })
  }

  execute() {

    this.isDisabled = true;
    this.submitted = true;

    if (this.orderForm.invalid) {
      this.isDisabled = false;
      return;
    } else {

      this.captcha.execute();
      setTimeout(() => {
        if (this.needToDisable == true) {
          this.isDisabled = false
        }

      }, 5000);

    }
  }
  doPurchaseOnServer(data, callback) {

    if(data.phone && data.phone.length > 0) {
      data.phone = encodeURIComponent(data.phone);
    }
    this.sub0 = this.customRequestService.postRequestWithFormData(this.lzProductConfig.getApiLink() + '/store/order/v1.0/orderTest', data, {}, {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      })
      .subscribe((msg) => {
          this.isDisabled = true;
          if (data.trial) {
            if (!window['dataLayer']) {
              window['dataLayer'] = [];
            }
            window['dataLayer'].push({
              'event': 'autoEvent',
              'eventCategory': 'order-test',
              'eventAction': data.productCode + '-test',
              'eventLabel': this.lzCookie.getCookie('referer') ? decodeURIComponent(this.lzCookie.getCookie('referer')) : window.location.href
            });
            this.isDisabled = false;
          }
          if (callback) {
            callback(msg);
            this.isDisabled = false;
          }
          if (msg.isOk != true) {
            this.captcha.resetCaptcha();
            try {
              grecaptcha.reset();
            } catch(e) { }
            this.isDisabled = false;
          }
        },
        (error) => {
          this.captcha.resetCaptcha();
          try {
            grecaptcha.reset();
          } catch(e) { }
          this.isDisabled = false;
        });

  }

  doPurchase() {
    this.from = (typeof this.from == 'undefined') ? 'ipas_commercial' : this.from;
    this.isTrial = (typeof this.isTrial == 'undefined') ? false : this.isTrial;

    try {
      this.user.getUserInfo((response) => {
        if (response) {
          this.buy.firstName = (response.name) ? response.name : '';
          this.buy.lastName = (response.lastName) ? response.lastName : '';
          this.buy.email = (response.email) ? response.email : '';
          this.buy.phone = (response.phone) ? response.phone : '';
          this.buy.dealerId = (response.dialer.id) ? response.dialer.id : '';
          this.buy.companyName = (response.client.name) ? response.client.name : '';
        }
      });
    } catch (error) {
      console.log("Error while trying to get userInfo (user.getUserInformation)");
    }
  }

  orderTest(captchaResponse: string) {

    this.needToDisable = false;
    this.isDisabled = true;

    let siteSource = '';
    if (!!(this.lzCookie.getCookie('referer'))) {
      siteSource = decodeURIComponent(this.lzCookie.getCookie('referer'));
    } else {
      siteSource = window.location.href;
      if (siteSource.indexOf('?') != -1) {
        siteSource = siteSource.split('?')[0];
      }
    }

    let params = {
      email: this.buy.email,
      firstName: this.buy.firstName,
      lastName: this.buy.lastName,
      phone: this.buy.phone.replace(/[^0-9+]/g, ""),
      companyName: this.buy.companyName,
      activity: '',
      productCode: this.alias,
      utm_source: this.lzCookie.getCookie('utm_sourceHistory') || '',
      utm_medium: this.lzCookie.getCookie('utm_mediumHistory') || '',
      utm_campaign: this.lzCookie.getCookie('utm_campaignHistory') || '',
      dealerId: this.lzCookie.getCookie('dealerIdHistory') || this.buy.dealerId,
      partnerCode: this.lzCookie.getCookie('partnerCodeHistory') || '',
      lz_source: this.lzCookie.getCookie('lz_source') || '',
      dispMode: "ipas",
      trial: this.isTrial,
      'g-recaptcha-response': captchaResponse,
      "Accept-Language": this.lang,
      'site_source': siteSource
    };

    this.submitPurchase(params);

  }

  submitPurchase(data) {
    this.serverError = false;
    this.isDisableCancel = true;

    this.buy['message'] = "";
    this.buy['site_source'] = location.href;
    let key;
    let callback = (response) => {
      this.isDisabled = true;
      if (typeof response.message != 'object' || Object.keys(response.message).length == 0) {
        for (key in this.serverValidation) {
          this.serverValidation[key].invalid = false;
          this.serverValidation[key].message = "";
        }
        this.isDisabled = false;
        this.thnxForPurchase.openThnx({
          'response': response ? response : '',
          'title': this.product.title ? this.product.title : '',
          'description': this.product.description ? this.product.description : ''
        });
        this.dialogRef.close('no-referer');

        this.isDisableCancel = false;
      } else {
        for (key in response.message) {
          if (this.buy.hasOwnProperty(key)) {
            this.serverValidation[key].invalid = true;
            this.serverValidation[key].message = response.message[key];
          }
        }
        this.isDisableCancel = false;
        this.buy.message = "error";
        this.serverError = true;
        this.captcha.resetCaptcha();
        try {
          grecaptcha.reset();
        } catch(e) { }
        this.isDisabled = false;

        setTimeout(() => {
          this.serverError = false;
        }, 5000)

      }
      this.isDisabledSubmitButton = false;

    };


    this.doPurchaseOnServer(data, callback.bind(this));
  };

  onResize(event) {
    let width = $(document).width();
    if (!this.checkSliderWidth(this.documentWidth, width)) {
      this.isSliderFirstPick = true;
      this.documentWidth = width;
      this.setActiveSpecified(this.currentActiveImg);
    }
  }

  private checkSliderWidth = (lastWidth, currentWidth): boolean => {
    if (lastWidth >= 1490 && currentWidth >= 1490 ||
      lastWidth >= 1002 && currentWidth >= 1002 && lastWidth < 1490 && currentWidth < 1490 ||
      lastWidth >= 758 && currentWidth >= 758 && lastWidth < 1002 && currentWidth < 1002 ||
      lastWidth >= 480 && currentWidth >= 480 && lastWidth < 758 && currentWidth < 758 ||
      lastWidth >= 0 && currentWidth >= 0 && lastWidth < 480 && currentWidth < 480) {
      return true;
    }
    return false;
  }

  //default count == 1
  public setActiveNext = (count ? ) => {
    let cnt = count || 1;
    this.isAnimate = true;

    if (this.documentWidth <= 480) {
      this.controlAnimation = (-100 * cnt) + '%';
    }
    if (this.documentWidth <= 758) {
      this.controlAnimation = (-50 * cnt) + '%';
    }

    this.currentActiveImg = this.product.presentation.slides[this.currentActiveImgPosition + cnt];

    setTimeout(() => {
      setTimeout(() => {
        this.isAnimate = false;
        this.controlAnimation = '0';
        this.product.presentation.slides = this.product.presentation.slides.splice(cnt, this.product.presentation.slides.length - 1)
          .concat(this.product.presentation.slides.splice(0, cnt));
        this.swipedetect(this.lastSwipeElement, $("#swipe.active"));
      }, 0);
    }, 0);
  }

  //default count == 1
  public setActivePrev = (count ? ) => {
    let cnt = count || 1;
    let product = this.product.presentation.slides[this.currentActiveImgPosition - cnt];
    this.isAnimate = true;

    this.product.presentation.slides = this.product.presentation.slides.splice(this.product.presentation.slides.length - cnt, this.product.presentation.slides.length)
      .concat(this.product.presentation.slides.splice(0, this.product.presentation.slides.length));

    if (this.documentWidth <= 480) {
      this.controlAnimation = (-100 * cnt) + '%';
    }
    if (this.documentWidth <= 758) {
      this.controlAnimation = (-50 * cnt) + '%';
    }

    setTimeout(() => {
      this.controlAnimation = '0';
      this.isAnimate = true;
      if (product) {
        this.currentActiveImg = product;
      } else {
        this.currentActiveImg = this.product.presentation.slides[0];
      }

      setTimeout(() => {
        this.isAnimate = false;
        this.swipedetect(this.lastSwipeElement, $("#swipe.active"));
      }, 500);
    }, 0);
  }


  private setActiveSpecified = (img) => {
    if (!this.isSliderFirstPick) {
      if (img == this.currentActiveImg) {
        return;
      }
      if (this.product.presentation.slides.indexOf(img) - this.currentActiveImgPosition >= 1) {
        this.setActiveNext(this.product.presentation.slides.indexOf(img) - this.currentActiveImgPosition);
        return;
      }
      if (this.product.presentation.slides.indexOf(img) - this.currentActiveImgPosition <= -1) {
        this.setActivePrev((this.product.presentation.slides.indexOf(img) - this.currentActiveImgPosition) * -1);
        return;
      }
    }
    let position = 0;

    let elementsCount = position - this.product.presentation.slides.indexOf(img);

    if (elementsCount < 0) {
      elementsCount *= -1;
      this.product.presentation.slides = this.product.presentation.slides.slice(elementsCount, this.product.presentation.slides.length)
        .concat(this.product.presentation.slides.slice(0, elementsCount));
    } else {
      this.product.presentation.slides = this.product.presentation.slides.slice(this.product.presentation.slides.length - elementsCount, this.product.presentation.slides.length)
        .concat(this.product.presentation.slides.slice(0, this.product.presentation.slides.length - elementsCount));
    }

    this.isSliderFirstPick = false;
    this.currentActiveImgPosition = position;
    this.currentActiveImg = img;

    setTimeout(() => {
      this.swipedetect(this.lastSwipeElement, $("#swipe.active"));
    }, 0);
  }

  private swipedetect = (lastEl, el, callback ? ) => {
    if (this.product.presentation.slides.length == 1) {
      return;
    }
    try {
      lastEl.off();
    } catch (e) {

    } finally {
      this.lastSwipeElement = el;
      let touchsurface = el,
        swipedir,
        startX,
        startY,
        distX,
        distY,
        threshold = 100, //required min distance traveled to be considered swipe
        restraint = 100, // maximum distance allowed at the same time in perpendicular direction
        allowedTime = 300, // maximum time allowed to travel that distance
        elapsedTime,
        startTime,
        handleswipe = callback || function (swipedir) {
          if (swipedir == 'right') {
            this.setActivePrev();
          }
          if (swipedir == 'left') {
            this.setActiveNext();
          }
        }.bind(this);

      touchsurface.on({
        'touchstart': function (e) {
          var touchobj = e.changedTouches[0];
          swipedir = 'none';
          distX = 0;
          distY = 0;
          startX = touchobj.pageX;
          startY = touchobj.pageY;
          startTime = new Date().getTime(); // record time when finger first makes contact with surface
          // e.preventDefault();
        }
      }, false);

      touchsurface.on({
        'touchmove': function (e) {
          // e.preventDefault() // prevent scrolling when inside DIV
        }
      }, false);

      touchsurface.on({
        'touchend': function (e) {
          var touchobj = e.changedTouches[0];
          distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
          distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
          elapsedTime = new Date().getTime() - startTime; // get time elapsed
          if (elapsedTime <= allowedTime) { // first condition for awipe met
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) { // 2nd condition for horizontal swipe met
              swipedir = (distX < 0) ? 'left' : 'right'; // if dist traveled is negative, it indicates left swipe
              e.preventDefault();
            } else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) { // 2nd condition for vertical swipe met
              swipedir = (distY < 0) ? 'up' : 'down'; // if dist traveled is negative, it indicates up swipe
            }
          }
          handleswipe(swipedir);
          e.preventDefault();
        }
      }, false);
    }
  }

  watchErrorRequired() {
    let values: Observable < number > = interval(100);
    let fnRequired: string;
    let lnRequired: string;
    let emailRequired: string;
    let phoneRequired: string;
    let companyRequired: string;
    let cptchwrppr: any;
    let cptch: any;
    let body: any = document.body;

    this.translate.get('lzPurchase.firstNameRequired').subscribe(trans => fnRequired = trans);
    this.translate.get('lzPurchase.enterLastnameRequired').subscribe(trans => lnRequired = trans);
    this.translate.get('lzPurchase.emailRequired').subscribe(trans => emailRequired = trans);
    this.translate.get('lzPurchase.phoneRequired').subscribe(trans => phoneRequired = trans);
    this.translate.get('lzPurchase.companyNameRequired').subscribe(trans => companyRequired = trans);

    this.sub2 = values.subscribe(() => {
      if ((this.orderForm.get('firstname').invalid && this.orderForm.get('firstname').touched &&
          this.orderForm.get('firstname')['errors']['required']) || (this.orderForm.get('firstname').invalid && this.submitted &&
          this.orderForm.get('firstname')['errors']['required'])) {
        $('#firstname').attr('placeholder', fnRequired);
      }
      if ((this.orderForm.get('lastname').invalid && this.orderForm.get('lastname').touched &&
          this.orderForm.get('lastname')['errors']['required']) || (this.orderForm.get('lastname').invalid && this.submitted &&
          this.orderForm.get('lastname')['errors']['required'])) {
        $('#lastname').attr('placeholder', lnRequired);
      }
      if ((this.orderForm.get('email').invalid && this.orderForm.get('email').touched &&
          this.orderForm.get('email')['errors']['required']) || (this.orderForm.get('email').invalid && this.submitted &&
          this.orderForm.get('email')['errors']['required'])) {
        $('#e-mail').attr('placeholder', emailRequired);
      }
      if ((this.orderForm.get('phone').invalid && this.orderForm.get('phone').touched &&
          this.orderForm.get('phone')['errors']['required']) || (this.orderForm.get('phone').invalid && this.submitted &&
          this.orderForm.get('phone')['errors']['required'])) {
        $('#phone').attr('placeholder', phoneRequired);
      }
      if ((this.orderForm.get('company').invalid && this.orderForm.get('company').touched &&
          this.orderForm.get('company')['errors']['required']) || (this.orderForm.get('company').invalid && this.submitted &&
          this.orderForm.get('company')['errors']['required'])) {
        $('#company').attr('placeholder', companyRequired);
      }

      if (this.submitted && !this.orderForm.invalid) {

        if (cptchwrppr != $(body).children('div')[$(body).children('div').length - 1]) {
          cptchwrppr = $(body).children('div')[$(body).children('div').length - 1];
        }
        cptch = $(cptchwrppr).children('div')[1];
        $(cptch).css('position', 'fixed');
        this.submitted = false;
      }
    })

    this.sub3 = this.orderForm.valueChanges.subscribe(() => {
      this.serverError = false;
      for (let key in this.serverValidation) {

        this.serverValidation[key].invalid = false;


      }
    })
  }

  ngOnDestroy() {
    if (this.sub0) {
      this.sub0.unsubscribe();
    }
    if (this.sub1) {
      this.sub1.unsubscribe();
    }
    if (this.sub2) {
      this.sub2.unsubscribe();
    }
    if (this.sub3) {
      this.sub3.unsubscribe();
    }
    if (this.sub4) {
      this.sub4.unsubscribe();
    }
  }
}
